$(document).ready(function(){
    
   let loadingElement = '<img src="data:image/gif;base64,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" />';

   // 根据URL参数判断默认赛道：带zhihu参数时默认打开小说赛道
   (function initTrackByUrl(){
       let search = window.location.search.substring(1);
       if(!search) return;
       let params = {};
       search.split('&').forEach(function(item){
           let arr = item.split('=');
           params[decodeURIComponent(arr[0])] = decodeURIComponent(arr[1] || '');
       });
       if(params.hasOwnProperty('zhihu')){
           $('.tgTab span').removeClass('active');
           $('.tgTab span').eq(1).addClass('active');
           $('.tgContent').hide();
           $('.tgContent').eq(1).show();
       }
   })();

   const url = "https://feature.people.cn/"

   function tjAI(){
     let shuPendingData = {};
     let movePendingData = {};
   }

   tjAI.prototype.upFile = function(file){
     var formData = new FormData();
        formData.append('file', file); 

        $('.loading').show();
        $('.loadingBox').html(loadingElement);
        $('.blackBg').show();
        
        $.ajax({
            type: 'POST',
            url: url+"api/vote/upload",
            data: formData,
            dataType: 'json',
            processData: false,
            contentType: false,
            success: function(res) {
                console.log('上传图片信息:', res)
                $('.loading').hide();
                $('.blackBg').hide();
                $('.upImg').addClass('upImg_c');
                $('#p_cover_url').val(res.url);
                showCoverPreview(res.url);
			
            },
            error: function(err) {
              console.log(err)
            }
        })
   }
   // 通用单张图片上传，返回 Promise<url>（用于佐证材料等多图依次上传）
   tjAI.prototype.upEvidenceImage = function(file){
      return new Promise(function(resolve, reject){
         var formData = new FormData();
         formData.append('file', file);
         $('.loading').show();
         $('.loadingBox').html(loadingElement);
         $('.blackBg').show();
         $.ajax({
            type: 'POST',
            url: url+"api/vote/upload",
            data: formData,
            dataType: 'json',
            processData: false,
            contentType: false,
            success: function(res){ resolve(res.url); },
            error: function(err){ reject(err); }
         }).always(function(){
            $('.loading').hide();
            $('.blackBg').hide();
         });
      });
   };

   tjAI.prototype.upVideo = async function(status){
        if (!file) {
          alert('请选择视频');
          return;
        }
		const MAX_SIZE = 1 * 1024 * 1024 * 1024; 
		console.log(file.size)
		if(file.size > MAX_SIZE){
			alert('视频大小超过1G')
			return
		}
		$('.loading').show();
        $('.loadingBox').html(loadingElement);
        $('.blackBg').show();
		$('#progressText').show();
//        setStatus('准备初始化分片上传...');
		
		const initRes = await $.ajax({
          url: url+'api/zos/direct-upload/init',
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify({
            filename: file.name,
			mime_type: "video/mp4",
            file_size: file.size
          })
        });
		
		const uploadId = initRes.upload_id;
        const key = initRes.key;
        const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
        const parts = [];

				for (let i = 0; i < totalChunks; i++) {
					  const partNumber = i + 1;
					  const start = i * CHUNK_SIZE;
					  const end = Math.min(start + CHUNK_SIZE, file.size);
					  const chunk = file.slice(start, end);

//					  setStatus(`正在上传第 ${partNumber}/${totalChunks} 片`);
					
					   const getsign = await $.ajax({
						  url: url+'api/zos/direct-upload/sign-part',
						  type: 'POST',
						  contentType: 'application/json',
						  data: JSON.stringify({
							upload_id: initRes.upload_id,
							key: initRes.key,
							part_number:partNumber
						  })
						});
					
					    const signedUrl = getsign.signed_url;
					
					     const uploadRes = await fetch(signedUrl, {
							method: 'PUT',
							body: chunk
						  })
					
						 const etag = uploadRes.headers.get('ETag')
						 
						 console.log('etag:',etag)
						 
						 parts.push({
							PartNumber: partNumber,
							ETag: etag
						 })

					  // 更新进度
					  const percent = ((partNumber / totalChunks) * 100).toFixed(0);
					  $('#progressText').text(percent+'%');
					  $('#progressBar').val(percent);
				}
		
				const backvideo = await $.ajax({
				  url: url+'api/zos/direct-upload/complete',
				  type: 'POST',
				  contentType: 'application/json',
				  data: JSON.stringify({
					upload_id: uploadId,
					key: key,
					file_size: file.size,
					parts: parts
				  }),
				  
				});
		 
		        console.log('backvideo',backvideo.key)
		
		        $('.loading').hide();
					  $('.blackBg').hide();
            $('#progressText').hide();
            $('.upVideo').addClass('upVideo_c');
				    $('.chenggong').show();
            $('#p_video_url').val(backvideo.url);
            showVideoPreview(backvideo.url);
		
   }
   tjAI.prototype.upVideos = async function(file, currentIndex, totalCount, finishCount){
        if (!file) {
        alert('文件无效');
        return;
		}
		const MAX_SIZE = 1 * 1024 * 1024 * 1024;
		console.log(file.size)
		if(file.size > MAX_SIZE){
			alert(`【${file.name}】视频大小超过1G`)
			return
		}

		const initRes = await $.ajax({
			url: url+'api/zos/direct-upload/init',
			type: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({
				filename: file.name,
				mime_type: "video/mp4",
				file_size: file.size
			})
		});

		const uploadId = initRes.upload_id;
		const key = initRes.key;
		const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
		const parts = [];

		for (let i = 0; i < totalChunks; i++) {
			const partNumber = i + 1;
			const start = i * CHUNK_SIZE;
			const end = Math.min(start + CHUNK_SIZE, file.size);
			const chunk = file.slice(start, end);

			const getsign = await $.ajax({
				url: url+'api/zos/direct-upload/sign-part',
				type: 'POST',
				contentType: 'application/json',
				data: JSON.stringify({
					upload_id: initRes.upload_id,
					key: initRes.key,
					part_number:partNumber
				})
			});

			const signedUrl = getsign.signed_url;

			const uploadRes = await fetch(signedUrl, {
				method: 'PUT',
				body: chunk
			})

			const etag = uploadRes.headers.get('ETag')
			console.log('etag:',etag)

			parts.push({
				PartNumber: partNumber,
				ETag: etag
			})
			// 当前文件分片百分比，同时显示总完成数量
			const percent = ((partNumber / totalChunks) * 100).toFixed(0);
			$('#progressText').text(`总进度：${finishCount}/${totalCount} | 正在上传第${currentIndex}个：${percent}%`);
			$('#progressBar').val(percent);
		}

		const backvideo = await $.ajax({
			url: url+'api/zos/direct-upload/complete',
			type: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({
				upload_id: uploadId,
				key: key,
				file_size: file.size,
				parts: parts
			}),
		});

		console.log('backvideo',backvideo.key)
		return backvideo.url;
		
   }
   tjAI.prototype.getcode = function(phone,captchaVerifyParam,btn){

        var formData = new FormData();
        formData.append('phone', phone);
		    formData.append('CaptchaVerifyParam',captchaVerifyParam)

        $.ajax({
            type: 'POST',
            url: url+'api/vote/sendsms',
            data: formData,
            dataType: 'json',
            processData: false,
            contentType: false,
            success: function(res) {
                // console.log('手机验证码:', res)
                alert(res.message)
                startCountdown(btn);
            },
            error: function(error) {
              alert(JSON.parse(error.responseText).message)
            }
        })
   }

   tjAI.prototype.postShu = function(obj){
        $.ajax({
            type: 'POST',
            url: url+'api/vote/my-registrations',
            data: obj,
            dataType: 'json',
            headers: { 'Authorization': 'Bearer ' + (localStorage.getItem('aiTjToken') || '') },
            success: function(res) {
                console.log('小说赛道提交结果:', res)
                if(res.code == 0){
                    $('.shu_tip').show();
                    $('.blackBg').show();
                    $('.tip_close').on('click',function(){
                        $('.shu_tip').hide();
                        $('.blackBg').hide();
                    })
                }
                if(res.code != 0){
                    alert(res.message)
                }
            },
            error: function(error) {
              alert(JSON.parse(error.responseText).message)
            }
        })
   }
      tjAI.prototype.postMove = function(obj){
        $.ajax({
            type: 'POST',
            url: url+'api/vote/my-registrations',
            data: obj,
            dataType: 'json',
            headers: { 'Authorization': 'Bearer ' + (localStorage.getItem('aiTjToken') || '') },
            success: function(res) {
                console.log('音视频赛道提交结果:', res)
                if(res.code == 0){
                    $('.blackBg').show();
                    $('.shu_tip1').show();
                    $('.tip_close1').on('click',function(){
                        $('.shu_tip1').hide();
                        $('.blackBg').hide();
                    })
                }
                if(res.code != 0){
                    alert(res.message)
                }
            },
            error: function(error) {
              alert(JSON.parse(error.responseText).message)
            }
        })
   }
   tjAI.prototype.postMov = function(obj){
    $.ajax({
            type: 'POST',
            url: url+'api/vote/my-registrations',
            data: obj,
            dataType: 'json',
            success: function(res) {
                console.log('小说赛道提交结果:', res)
                if(res.code == 0){
                    $('.shu_tip').show();
                    $('.blackBg').show();
                    $('.tip_close').on('click',function(){
                        $('.shu_tip').hide();
                        $('.blackBg').hide();
                    })
                }
                if(res.code != 0){
                    alert(res.message)
                }
            },
            error: function(error) {
              alert(JSON.parse(error.responseText).message)
            }
        })
   }
   tjAI.prototype.login = function(phone,smsmsg){
     return new Promise((resolve, reject) => {
         $.ajax({
            type: 'POST',
            url: url+"api/vote/auth/login",
            dataType: 'json',
            data:{
                phone:phone,
                smsmsg:smsmsg
            },
            success: function(res) {
                console.log('登录:', res)
                resolve(res)
            },
            error: function(err) {
                reject(err)
            }
        })
     })
   }
   // 我的作品列表
   tjAI.prototype.myRegistrations = function(){
      // TODO: 接入真实接口（路径含 api，鉴权放 header 的 Authorization）
      // 真实实现：
      return new Promise((resolve, reject) => {
         $.ajax({
            type: 'GET',
            url: url + 'api/vote/my-registrations',
            dataType: 'json',
            headers: { 'Authorization': 'Bearer ' + (localStorage.getItem('aiTjToken') || '') },
            success: function(res){ resolve(res); },
            error: function(err){ reject(err); }
         });
      });
   }
   // 我的作品详情（单条）：GET /api/vote/my-registrations/{id}，鉴权放 header 的 Authorization
   tjAI.prototype.myRegistrationDetail = function(id, track){
      return new Promise((resolve, reject) => {
         $.ajax({
            type: 'GET',
            url: url + 'api/vote/my-registrations/' + id,
            dataType: 'json',
            headers: { 'Authorization': 'Bearer ' + (localStorage.getItem('aiTjToken') || '') },
            success: function(res){ resolve(res); },
            error: function(err){ reject(err); }
         });
      });
   }
   //60秒倒计时
   function startCountdown(btn){
       let $btn = $(btn);
       let count = 60;
       $btn.addClass('disabled').css({'pointer-events':'none','opacity':'0.6'});
       $btn.text(count+'秒后重试');
       let timer = setInterval(function(){
           count--;
           if(count <= 0){
               clearInterval(timer);
               $btn.removeClass('disabled').css({'pointer-events':'auto','opacity':'1'});
               $btn.text('获取验证码');
           }else{
               $btn.text(count+'秒后重试');
           }
       },1000);
   }

   //获取验证码
   let captcha = "";
   let isCountDown = false;

   // 登录弹窗（手机号 + 验证码）全局状态
   let loginPhone = '';
   let loginCode = '';
   function showLoginModal(){ $('#login_modal').css('display','flex'); }
   function hideLoginModal(){ $('#login_modal').css('display','none'); }
   function isLogined(){ return !!loginPhone && !!loginCode; }

   //音视频赛道邮箱验证
   $('#p_email').on('blur',function(){
       let email = $(this).val();
       if(!validateEmail(email)){
           alert('请输入正确的邮箱格式');
           return false;
       }
   });

   //音视频赛道填报方式切换
   const pTeamInputs = ['#p_unit_name','#p_team_contact','#p_team_phone','#p_team_creator'];
   let p_fill_type = "";
   $('#p_fill_type').on('change',function(){
       let type = $(this).val();
       if(type == '团队填报'){
           $('#p_team_container').show();
           p_fill_type = '团队填报';
       }else{
           $('#p_team_container').hide();
           pTeamInputs.forEach(function(id){ $(id).val(''); });
           p_fill_type = '个人填报';
       }
   });

   // 登录弹窗：获取验证码
   $('#login_getCode').on('click',function(){
        if($(this).hasClass('disabled')){
            return false;
        }
        let phone = $('#login_phone').val();
        if(phone == ''){
            $('#login_err').text('请输入手机号');
            return false;
        }
        if(!validatePhone(phone)){
            $('#login_err').text('请输入正确的手机号格式');
            return false;
        }
        $('#login_err').text('');

        $('.blackBg').show();
		$('.huaBox').show();

        window.initAliyunCaptcha({
			SceneId: "gds8ripc",
			mode: "embed",
			element: "#captcha-element",
			success: function (captchaVerifyParam) {
				console.log('验证通过:',captchaVerifyParam)
				tjObj.getcode(phone,captchaVerifyParam,'#login_getCode');
				$('.blackBg').hide();
		        $('.huaBox').hide();
			},
			fail: function (result) {
			  console.error(result);
			},
			getInstance: function (instance) {
			  captcha = instance;
			},
			slideStyle: {
			  width: 360,
			  height: 40,
			},
		  });
   })



   //全局调用
   let tjObj = new tjAI();
   //视频上传
   const CHUNK_SIZE = 10 * 1024 * 1024; // 10MB 一片
   let file = null;


    // 登录弹窗：点击登录
   $('#login_submit').on('click',function(){
        let phone = $('#login_phone').val();
        let code = $('#login_smsmsg').val();
        if(phone == ''){
            $('#login_err').text('请输入手机号');
            return false;
        }
        if(!validatePhone(phone)){
            $('#login_err').text('请输入正确的手机号格式');
            return false;
        }
        if(code == ''){
            $('#login_err').text('请输入短信验证码');
            return false;
        }
        $('#login_submit').prop('disabled', true);
        $('#login_err').text('');

        tjObj.login(phone, code).then(function(res){
            if(res && res.code == 0){
                // 兼容多种返回结构，提取 token
                let token = '';
                if(res.data){
                    token = res.data.token || res.data.Token || (res.data.data && res.data.data.token) || '';
                }
                if(!token){
                    token = res.token || res.Token || '';
                }
                if(token){
                    // 存储到本地（同时记录获取时间，用于 24h 有效期判断）
                    localStorage.setItem('aiTjToken', token);
                    localStorage.setItem('aiTjTokenTime', String(Date.now()));
                    loginPhone = phone;
                    loginCode = code;
                    showAuthButtons();
                    $('#login_err').text('');
                }else{
                    $('#login_err').text((res && res.message) || '登录成功但未获取到凭证');
                }
                hideLoginModal();
            }else{
                $('#login_err').text((res && res.message) || '手机验证失败，请重试');
            }
        }).catch(function(){
            $('#login_err').text('网络异常，请稍后重试');
        }).always(function(){
            $('#login_submit').prop('disabled', false);
        });
   })

   $('#p_upVideo').on('change',function(e){
		file = e.target.files[0];
		console.log('选择文件:',file)
		tjObj.upVideo(1);
   })
	$('#p_upVideos').on('change',async function(e){
		const fileList = Array.from(e.target.files);
		console.log('选择文件列表:', fileList);
		if(fileList.length === 0) return;

		const allUrls = [];
		const totalFiles = fileList.length;
		let finishCount = 0; // 已经上传完成的文件数量

		// 显示loading遮罩
		$('.loading').show();
		$('.loadingBox').html(loadingElement);
		$('.blackBg').show();
		$('#progressText').show();

		// 串行逐个上传
		for(let i = 0; i < totalFiles; i++){
			const file = fileList[i];
			const currentFileIndex = i + 1;
			try{
				const url = await tjObj.upVideos(file, currentFileIndex, totalFiles, finishCount);
				allUrls.push(url);
				finishCount++;
				// 每完成一个，更新总进度文本，进度条置满100
				$('#progressText').text(`进度：${finishCount}/${totalFiles}已完成`);
				$('#progressBar').val(100);
			}catch(err){
				console.error('上传失败', err);
				alert(`第${currentFileIndex}个视频【${file.name}】上传失败`);
				finishCount++;
				$('#progressText').text(`进度：${finishCount}/${totalFiles}  其中一个失败`);
				$('#progressBar').val(100);
			}
		}

		// 全部任务结束
		$('.loading').hide();
		$('.blackBg').hide();
		$('#progressText').hide();
		$('.upVideo').addClass('upVideo_c');
		$('.chenggong').show();
		$('#p_video_url').val(allUrls.join(','));
		showVideoPreview($('#p_video_url').val());
		console.log('全部上传完成，url集合：', allUrls);
   })

   /*====音视频赛道提交========*/
   //显示版权确认弹窗
   function showPCopyrightModal(){
       $('#blackBg, .blackBg').show();
       $('#p_copyright_modal').show();
       //重置勾选状态：未勾选 + 按钮禁用
       $('#p_copyright_agree').prop('checked', false);
       $('#p_copyright_confirm').addClass('disabled').prop('disabled', true);
   }

   //隐藏版权确认弹窗
   function hidePCopyrightModal(){
       $('#p_copyright_modal').hide();
       $('.blackBg').hide();
   }

   //勾选版权同意-切换提交按钮状态
   $('#p_copyright_agree').on('change', function(){
       if($(this).is(':checked')){
           $('#p_copyright_confirm').removeClass('disabled').prop('disabled', false);
       }else{
           $('#p_copyright_confirm').addClass('disabled').prop('disabled', true);
       }
   });

   //增加组别选择
   let p_group_name = "";
   $('#p_group_name').on('change',function(){
       p_group_name = $('#p_group_name option:selected').text();
       console.log('组别:',p_group_name)
	   //仅高校组显示指导老师字段
       if(p_group_name == '高校组'){
           $('#p_advisor_box').show();
       }else{
           $('#p_advisor_box').hide();
           $('#advisor').val('');
       }
   })
   //增加类别选择
   let p_category_name = "";
   $('#p_category_name').on('change',function(){
       p_category_name = $('#p_category_name option:selected').text();
       console.log('类别:',p_category_name)
   })

   //封面上传
   $('#p_upFace').on('change',function(e){
		let file = e.target.files[0];
		console.log('选择文件:',file)
		tjObj.upFile(file);
   })

   // 佐证材料：多选（最多5张图片），依次上传，地址以逗号拼接存入 evidence_urls
   $('#p_upZuo').on('change', async function(e){
      const files = Array.from(e.target.files || []).filter(function(f){
         return /^image\//.test(f.type);
      });
      e.target.value = ''; // 允许重复选择同一文件
      if(files.length === 0){ return; }
      if(files.length > 5){
         alert('最多上传5张图片，已取前5张');
         files.splice(5);
      }
      const $preview = $('#zuoPreview');
      $preview.empty().hide();
      const urls = [];
      try{
         for(let i = 0; i < files.length; i++){
            const u = await tjObj.upEvidenceImage(files[i]);
            if(u){
               urls.push(u);
               $('<img>').attr('src', u).appendTo($preview);
            }
         }
         $('#evidence_urls').val(urls.join(','));
         if(urls.length){
            $('.upZuo').addClass('upZuo_c');
            $preview.show();
         }
      }catch(err){
         alert('图片上传失败，请重试');
      }
   })

   //音视频点击提交按钮
   $('#p_tijiao').on('click',function(){

        let name = $('#p_name').val();
        let email = $('#p_email').val();
        let phone = loginPhone;
        let code = loginCode;
        let videoname = $('#p_video_name').val();//视频名称
        let video_make_time = $('#p_video_make_time').val();//视频制作时间
        let p_video_desc = $('#p_video_desc').val();
        let p_video_keywords = $('#p_video_keywords').val();///视频关键词
        let p_recommend_unit = $('#p_recommend_unit').val();///推荐单位
        let cover_url = $('#p_cover_url').val();///视频封面
        let p_video_link = $('#p_video_link').val();///视频填报链接
        let p_unit_name = $('#p_unit_name').val();///单位名称
        let p_team_contact = $('#p_team_contact').val();///团队联系人
        let p_team_phone = $('#p_team_phone').val();///团队联系人电话
        let p_team_creator = $('#p_team_creator').val();///团队创建人
        let video_url = $('#p_video_url').val();///视频地址
	    let advisor = $('#advisor').val();///指导老师（高校组必填）
        let evidence_urls = $('#evidence_urls').val();///佐证材料

        if(p_group_name == ''){
            alert('请选择组别');
            return false;
        }
        if(p_category_name == ''){
            alert('请选择类别');
            return false;
        }
//	   if(p_group_name == '高校组' && advisor == ''){
//            alert('请填写指导老师');
//            return false;
//        }

        if(name == ''){
            alert('姓名不能为空');
            return false;
        }
        if(email == ''){
            alert('邮箱不能为空');
            return false;
        }
        if(!isLogined()){
            alert('请先完成手机验证登录');
            showLoginModal();
            return false;
        }
        if(videoname == ''){
            alert('视频名称不能为空');
            return false;
        }
        if(video_make_time == ''){
            alert('请输入视频制作时间');
            return false;
        }
        if(p_fill_type == ''){
            alert('请选择填报方式');
            return false;
        }

               if(p_fill_type == '团队填报'){
            if(p_unit_name == ''){
                alert('单位名称不能为空');
                return false;
            }
            if(p_team_contact == ''){
                alert('团队联系人不能为空');
                return false;
            }
            if(p_team_phone == ''){
                alert('团队联系人电话不能为空');
                return false;
            }
            if(p_team_creator == ''){
                alert('主创人员不能为空');
                return false;
            }
        }

        if(p_video_desc == ''){
            alert('视频简介不能为空');
            return false;
        }
        if(p_video_desc.length < 50){
            alert('视频简介字数不能小于50');
            return false;
        }
        if(p_video_desc.length > 5000){
            alert('视频简介字数不能超过5000');
            return false;
        }

        if(p_video_keywords == ''){
            alert('请输入视频关键词');
            return false;
        }
        if(cover_url == ''){
            alert('视频封面不能为空');
            return false;
        }
        if(video_url == ''){
            alert('请上传视频');
            return false;
        }



        let data = {
            track:"音视频",
            name: name,
            email: email,
            phone: phone,
            smsmsg: code,
            registration_type:p_fill_type,
            category: p_category_name,
            group_name: p_group_name,
            video_name: videoname,
            cover_url: cover_url,
            video_url: video_url,
            video_desc: p_video_desc,
            keywords: p_video_keywords,
            video_make_time: video_make_time,
            recommend_unit: p_recommend_unit,
            report_url: p_video_link,
            org_name: p_unit_name,
            contact_person: p_team_contact,
            main_creators: p_team_creator,
            contact_phone: p_team_phone,
            advisor: advisor,
            evidence_urls: evidence_urls,
            }
        tjObj.movePendingData = data;
        showPCopyrightModal();
   });

   //取消按钮
   $('#p_copyright_cancel').on('click',function(){
       hidePCopyrightModal();
       tjObj.movePendingData = null;
   });

   //点击遮罩关闭
   $('.blackBg').on('click',function(){
       if($('#p_copyright_modal').is(':visible')){
           hidePCopyrightModal();
       }
       if($('#shu_copyright_modal').is(':visible')){
           $('#shu_copyright_modal').hide();
           $('.blackBg').hide();
          //  tjObj.shuPendingData = null;
       }
   });

   //确认提交
   $('#p_copyright_confirm').on('click',function(){
       hidePCopyrightModal();
       if(tjObj.movePendingData){
          tjObj.postMove(tjObj.movePendingData);
          tjObj.movePendingData = null;
      }
   });

   //实际提交表单
   function submitPForm(){
       //TODO: 表单验证与提交逻辑
       alert('版权信息已确认，正在提交...');
   }
   /*====音视频赛道提交结束=====/

	/*====小说赛道提交========*/
  function validatePhone(phone){
        return /^1[3-9]\d{9}$/.test(phone);
    }
    function validateEmail(email){
        return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
    }

   //小说赛道邮箱验证
   $('#shu_email').on('blur',function(){
       let email = $(this).val();
       if(!validateEmail(email)){
           alert('请输入正确的邮箱格式');
           return false;
       }
   });

   //小说赛道作品简介字数验证(50~200字)
   $('#shu_zp_desc').on('blur',function(){
       let desc = $(this).val();
       let len = desc.length;
       if(len < 50){
           alert('作品简介至少50字，当前'+len+'字');
           return false;
       }
       if(len > 200){
           alert('作品简介不能超过200字，当前'+len+'字');
           return false;
       }
   });

  let shu_zp_word_count;//作品字数
  $('#shu_zp_word_count').on('change',function(){
    // 根据选择的字数显示对应提示
    shu_zp_word_count = $('#shu_zp_word_count option:selected').text();

  })
  $('#shu_tijiao').on('click',function(){
    let name = $('#shu_name').val();
    let email = $('#shu_email').val();
    let phone = loginPhone;
    let code = loginCode;
    let zpname = $('#shu_zpname').val();
    let shu_author_name = $('#shu_author_name').val();
    let shu_zpname = $('#shu_novel_protagonist').val();
    let shu_zp_desc = $('#shu_zp_desc').val();
    let shu_zp_keywords = $('#shu_zp_keywords').val();
    let shu_recommend_unit = $('#shu_recommend_unit').val();
  

    if(name == ''){
        alert('姓名不能为空');
        return false;
    }
    if(email == ''){
        alert('邮箱不能为空');
        return false;
    }
    if(!isLogined()){
        alert('请先完成手机验证登录');
        showLoginModal();
        return false;
    }
    if(shu_zp_desc == ''){
        alert('作品简介不能为空');
        return false;
    }
    if(shu_zp_desc.length < 50){
        alert('作品简介字数不能小于50');
        return false;
    }
    if(shu_zp_desc.length > 5000){
        alert('作品简介字数不能超过5000');
        return false;
    }
    if(shu_author_name == ''){
        alert('请输入作者笔名');
        return false;
    }
    if(zpname == ''){
        alert('请输入作品名称');
        return false;
    }
    if(shu_zpname == ''){
        alert('请输入小说主角名');
        return false;
    }

    if(shu_zp_word_count == ''){
        alert('请选择作品字数');
        return false;
    }
    if(shu_zp_keywords == ''){
        alert('请输入作品关键词');
        return false;
    }


    let data = {
        track:"小说",
        name: name,
        email: email,
        phone: phone,
        smsmsg: code,
        video_name: zpname,
        word_count: shu_zp_word_count,
        author_pen_name: shu_author_name,
        novel_protagonist: shu_zpname,
        video_desc: shu_zp_desc,
        keywords: shu_zp_keywords,
        recommend_unit: shu_recommend_unit,
    }

    //暂存数据并显示小说赛道版权确认弹窗
    tjObj.shuPendingData = data;
    $('#blackBg, .blackBg').show();
    $('#shu_copyright_modal').show();
    //重置勾选状态：未勾选 + 按钮禁用
    $('#shu_copyright_agree').prop('checked', false);
    $('#shu_copyright_confirm').addClass('disabled').prop('disabled', true);
  })

  //小说赛道版权确认弹窗-取消
  $('#shu_copyright_cancel').on('click',function(){
      $('#shu_copyright_modal').hide();
      $('.blackBg').hide();
      tjObj.shuPendingData = null;
  });

  //小说赛道勾选版权同意-切换提交按钮状态
  $('#shu_copyright_agree').on('change', function(){
      if($(this).is(':checked')){
          $('#shu_copyright_confirm').removeClass('disabled').prop('disabled', false);
      }else{
          $('#shu_copyright_confirm').addClass('disabled').prop('disabled', true);
      }
  });

  //小说赛道版权确认弹窗-确认提交
  $('#shu_copyright_confirm').on('click',function(){
      $('#shu_copyright_modal').hide();
      $('.blackBg').hide();
      if(tjObj.shuPendingData){
          tjObj.postShu(tjObj.shuPendingData);
          tjObj.shuPendingData = null;
      }
  });
  /*====小说赛道提交结束========*/

   //切换
   $('.tgTab span').on('click',function(){
		let index = $(this).index();
        $('.tgTab span').removeClass('active');
        $(this).addClass('active');
        $('.tgContent').hide();
        $('.tgContent').eq(index).show();
   })

   // HTML 转义，防止接口数据造成 XSS
   function escapeHtml(str){
       return String(str == null ? '' : str)
           .replace(/&/g, '&amp;')
           .replace(/</g, '&lt;')
           .replace(/>/g, '&gt;')
           .replace(/"/g, '&quot;')
           .replace(/'/g, '&#39;');
   }

   // 我的作品列表弹窗
   function showMyWorksModal(){ $('#myWorks_modal').css('display','flex'); }
   function hideMyWorksModal(){ $('#myWorks_modal').css('display','none'); }

   // 登录态相关的按钮显隐（未登录隐藏“我的作品列表”“退出”）
   function showAuthButtons(){ $('#myWorksBtn, #myWorks_logout').css('display','inline-block'); }
   function hideAuthButtons(){ $('#myWorksBtn, #myWorks_logout').css('display','none'); }

   // 我的作品列表：退出登录（调用 /vote/auth/logout，清除本地登录态）
   $('#myWorks_logout').on('click', function(){
        if(!confirm('确定要退出登录吗？')){ return false; }
        const token = localStorage.getItem('aiTjToken') || '';
        $.ajax({
            type: 'POST',
            url: url + 'api/vote/auth/logout',
            dataType: 'json',
            headers: { 'Authorization': 'Bearer ' + token }
        }).always(function(){
            // 无论接口成败，都清除本地登录态并回到登录弹窗
            localStorage.removeItem('aiTjToken');
            localStorage.removeItem('aiTjTokenTime');
            loginPhone = '';
            loginCode = '';
            hideMyWorksModal();
            showLoginModal();
            hideAuthButtons();
            alert('已退出登录');
        });
   });

   $('#myWorksBtn').on('click',function(){
        if(!isLogined()){
            // 过期或缺失：清掉本地登录态，重新登录
            localStorage.removeItem('aiTjToken');
            localStorage.removeItem('aiTjTokenTime');
            alert('登录已过期，请重新完成手机验证登录');
            showLoginModal();
            return false;
        }
        showMyWorksModal();
        $('#myWorks_loading').show();
        $('#myWorks_empty').hide().text('暂无作品');
        $('#myWorks_list').empty();

        tjObj.myRegistrations().then(function(res){
            $('#myWorks_loading').hide();
            let list = (res && res.data) ? (res.data.list || res.data.data || res.data) : (res || []);
            if($.isArray(list) && list.length){
                let html = '';
                list.forEach(function(item){
                    let title = item.name || item.title || item.video_name || item.work_name || item.zpname || '未命名作品';
                    let track = item.track || item.type || item.category || '';
                    let status = item.status || item.state || item.auditStatus || '';
                    let time = item.created_at || item.createTime || item.time || '';
                    html += '<li class="worksItem">'
                          + '<div class="worksTitle">' + escapeHtml(title) + '</div>'
                          + '<div class="worksMeta">'
                          + (track ? '<span>赛道：' + escapeHtml(track) + '</span>' : '')
                          + (status ? '<span>状态：' + escapeHtml(status) + '</span>' : '')
                          + (time ? '<span>提交：' + escapeHtml(time) + '</span>' : '')
                          + '<button type="button" class="worksEdit" data-id="' + escapeHtml(item.id) + '" data-track="' + escapeHtml(track) + '">编辑</button>'
                          + '<button type="button" class="worksDel" data-id="' + escapeHtml(item.id) + '">删除</button>'
                          + '</div>'
                          + '</li>';
                });
                $('#myWorks_list').html(html);
            }else{
                $('#myWorks_empty').show();
            }
        }).catch(function(){
            $('#myWorks_loading').hide();
            $('#myWorks_empty').text('加载失败，请稍后重试').show();
        });
   });

   // 编辑：获取单条详情并回填到对应赛道表单；小说赛道跳转到 edittxt.html，其余跳 editvideo.html
   $('#myWorks_list').on('click', '.worksEdit', function(){
        let id = $(this).data('id');
        let track = $(this).data('track');
        let target = (track === '小说') ? 'edittxt.html' : 'editvideo.html';
        window.open(target + '?id=' + encodeURIComponent(id) + (track ? '&track=' + encodeURIComponent(track) : ''), '_blank');
   });

   // 删除：DELETE /api/vote/my-registrations/{id}，成功后从列表移除该项
   $('#myWorks_list').on('click', '.worksDel', function(){
        let id = $(this).data('id');
        if(!id){ return false; }
        if(!confirm('确定要删除该作品吗？删除后不可恢复。')){ return false; }
        const $btn = $(this);
        const $li = $btn.closest('.worksItem');
        $btn.prop('disabled', true).text('删除中...');
        $.ajax({
            type: 'DELETE',
            url: url + 'api/vote/my-registrations/' + encodeURIComponent(id),
            dataType: 'json',
            headers: { 'Authorization': 'Bearer ' + (localStorage.getItem('aiTjToken') || '') },
            success: function(res){
                if(res && (res.code === 0 || res.code === '0' || res.success)){
                    $li.remove();
                    if(!$('#myWorks_list').children().length){
                        $('#myWorks_empty').show();
                    }
                    alert('删除成功');
                }else{
                    alert((res && res.message) || '删除失败，请稍后重试');
                    $btn.prop('disabled', false).text('删除');
                }
            },
            error: function(){
                alert('删除失败，请稍后重试');
                $btn.prop('disabled', false).text('删除');
            }
        });
   });

   // 封面 / 视频 预览（带入详情或上传成功后展示）
   function showCoverPreview(src){
      if(!src){ return; }
      $('#coverPreview img').attr('src', src);
      $('#coverPreview').show();
   }
   function hideCoverPreview(){
      $('#coverPreview img').attr('src', '');
      $('#coverPreview').hide();
   }
   // video_url 可能是一个或多个（逗号分隔），统一成数组
   function toUrlArray(src){
       if(!src){ return []; }
       if(Array.isArray(src)){ return src.slice(); }
       return String(src).split(',').map(function(s){ return $.trim(s); }).filter(Boolean);
   }
   function showVideoPreview(src){
      const list = toUrlArray(src);
      if(!list.length){ hideVideoPreview(); return; }
      const $list = $('#videoList');
      if(!$list.length){ return; }
      $list.empty();
      list.forEach(function(u){
          const $item = $('<div class="videoItem" style="position:relative;display:inline-block;margin:4px 8px 4px 0;vertical-align:top;"></div>');
          $item.append($('<video>').attr('src', u).attr('controls','').attr('preload','metadata').css('max-width','240px'));
          $item.append($('<span class="upVideoDel" title="删除该视频">×</span>').css({position:'absolute',top:'-6px',right:'-6px',cursor:'pointer',color:'#fff',background:'rgba(0,0,0,.6)',borderRadius:'50%',width:'18px',height:'18px',lineHeight:'18px',textAlign:'center'}).data('url', u));
          $list.append($item);
      });
      $('#videoPreview').show();
      $('.upVideo').addClass('upVideo_c');
   }
   function hideVideoPreview(){
      $('#videoList').empty();
      $('#videoPreview').hide();
      $('.upVideo').removeClass('upVideo_c');
   }
   // 删除已带入/已上传的封面、视频：清空 URL 并恢复上传入口
   $('.upDel').on('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      let type = $(this).data('type');
      if(type === 'cover'){
         $('#p_cover_url').val('');
         $('.upImg').removeClass('upImg_c');
         hideCoverPreview();
      }else if(type === 'video'){
         $('#p_video_url').val('');
         $('.upVideo').removeClass('upVideo_c');
         $('.chenggong').hide();
         hideVideoPreview();
      }
   });

   $('#myWorks_close').on('click',hideMyWorksModal);
   // 点击弹窗灰色区域关闭
   $('#myWorks_modal').on('click',function(e){
        if(e.target === this){ hideMyWorksModal(); }
   });
   $('#p_subTab span').on('click',function(){
		let index = $(this).index();
        $('#p_subTab span').removeClass('active');
        $(this).addClass('active');
        if(index == 0){
              $('#p_subTab').removeClass('subTab1');
        }
        if(index == 1){
             $('#p_subTab').addClass('subTab1');
        }
        $('.p_tgBox').hide();
        $('.p_tgBox').eq(index).show();
   })


   // 匹配所有锚点a标签
    $('.floatNav a[href^="#"]').on('click',function (e) {
        e.preventDefault(); // 取消原生瞬间跳转
        var target = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(target).offset().top-60
        }, 1000); // 700=滑动时间，毫秒，数值越大滑动越慢
    });

    //滚动
    let wenxueSwiper = new Swiper('#wenxueSwiper', {
      autoplay: true,//可选选项，自动滑动
      slidesPerView:3,
      loop:true,
    })
    let rightSwiper = new Swiper('.rightSwiper', {
      direction: 'vertical',
      autoplay: true,//可选选项，自动滑动
      slidesPerView:2,
      spaceBetween : 10,
      loop:true,
    })

    function isMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|HarmonyOS|OpenHarmony/i.test(navigator.userAgent);
    }

    if(isMobile()){
        
    }

    // 是否登录：token 存在 + 在 24 小时有效期内（后端 token 有时效限制）
    function isLogined(){
        const token = localStorage.getItem('aiTjToken');
        if(!token){ return false; }
        const t = Number(localStorage.getItem('aiTjTokenTime')) || 0;
        // 未记录获取时间时，视为过期，需重新登录
        if(!t){ return false; }
        return (Date.now() - t) < 24 * 60 * 60 * 1000;
    }

    // 页面首次进入：本地已有有效登录态则显示按钮，否则清除过期态并弹出手机验证登录弹窗
    if(!isLogined()){
        localStorage.removeItem('aiTjToken');
        localStorage.removeItem('aiTjTokenTime');
        hideAuthButtons();
        showLoginModal();
    }else{
        showAuthButtons();
    }

    // 供独立页面（editvideo.html / edittxt.html）复用：暴露实例、预览辅助方法与登录态判断/弹窗
    window.tjObj = tjObj;
    window.showCoverPreview = showCoverPreview;
    window.hideCoverPreview = hideCoverPreview;
    window.showVideoPreview = showVideoPreview;
    window.hideVideoPreview = hideVideoPreview;
    window.isLogined = isLogined;
    window.showLoginModal = showLoginModal;
    window.hideLoginModal = hideLoginModal;

})